import { parseFieldsArrayToObject } from '@interlayer/js/app/components/main/Registration/utils/parseFieldsArrayToObject';
import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

import { TAddressFields } from './types';

export const ADDRESS_FIELDS: TAddressFields[] = [
    VALIDATION_FIELDS.zip,
    VALIDATION_FIELDS.house,
    VALIDATION_FIELDS.street,
    VALIDATION_FIELDS.city,
    VALIDATION_FIELDS.state,
    VALIDATION_FIELDS.homeVenue,
    VALIDATION_FIELDS.searchAddress
];

export const ADDRESS_DATA = parseFieldsArrayToObject(ADDRESS_FIELDS);
